export default __webpack_public_path__ + "static/media/i_bus-dbl_gy_tagless.886f24e8.svg";